import { IOrder, IOrderAmounts } from '@core/order/models/order.model';
import { createBlankBookingAmounts } from '@roller/booking-calculation-service';

/** The order should always exist in checkout, this gives us the minimum required props */
export function getBlankOrder(): IOrder {
  return {
    items: [],
    discounts: [],
    giftCards: [],
    itemCount: 0,
    amounts: createBlankOrderAmounts(),
    createdDate: new Date(),
    lastUpdatedDate: new Date(),
    userData: {}
  };
}

export function createBlankOrderAmounts(): IOrderAmounts {
  return {
    ...createBlankBookingAmounts(),
    paid: 0,
    paidExcludingFees: 0,
    amountIfDepositOnly: 0
  };
}

/** Unit test helper for building an order based off a blank order but with minimal properties i.e. maybe you only need to set items or amounts for your unit test */
export function testOrder(props: Partial<IOrder>): IOrder {
  return {
    ...getBlankOrder(),
    ...props
  };
}
